import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "time-controller__inner" }
const _hoisted_2 = ["value"]
const _hoisted_3 = ["value"]
const _hoisted_4 = ["value"]
const _hoisted_5 = ["value"]

import { mapModifires, type typeModifires } from "@/components/utils/modifires";
import { withDefaults, ref, watch, Ref } from "vue";
import {
  FormUnit,
  FormUnitRow,
  FormUnitCell,
  SelectItem,
  ButtonItem,
  PopupWindow,
} from "..";

interface Props {
  modifires?: typeModifires;
  mapTime?: {
    year: string;
    month: string;
    day: string;
    hour: number;
    minute: number;
  };
  attributeTime?: {
    year: string;
    month: string;
    day: string;
    hour: number;
    minute: number;
  };
  isOpen?: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'time-controller',
  props: {
    modifires: { type: [String, Array, Boolean] },
    mapTime: {},
    attributeTime: {},
    isOpen: { type: Boolean }
  },
  emits: [
  "executeUpdateTime",
  "updateMapTime",
  "updateAttributeTime",
  "resetMapTime",
],
  setup(__props: any, { emit }) {

const props = __props;





/**
 * 地図・属性時間表示時間
 */
const mapTime = ref({
  year: "",
  month: "",
  day: "",
  hour: 0,
  minute: 0,
});

const mapDate: Ref<Date> = ref(null);

/**
 * 属性比較表示時間
 */
const attributeTime = ref({
  year: "",
  month: "",
  day: "",
  hour: 0,
  minute: 0,
});

const attributeDate: Ref<Date> = ref(null);

/**
 * ドラッグエリアスタイル
 */
const dragStyle = ref({
  top: window.document.body.clientHeight - 236 + "px",
  left: "280px",
});

/**
 * props更新
 */
watch(
  () => props.mapTime,
  () => {
    mapTime.value = props.mapTime;
    mapDate.value =
      mapTime.value.year &&
      Number(mapTime.value.month) >= 0 &&
      mapTime.value.day
        ? new Date(
            Number(mapTime.value.year),
            Number(mapTime.value.month) - 1,
            Number(mapTime.value.day)
          )
        : null;
  },
  { deep: true }
);

watch(
  () => props.attributeTime,
  () => {
    attributeTime.value = props.attributeTime;
    attributeDate.value =
      attributeTime.value.year &&
      Number(attributeTime.value.month) >= 0 &&
      attributeTime.value.day
        ? new Date(
            Number(attributeTime.value.year),
            Number(attributeTime.value.month) - 1,
            Number(attributeTime.value.day)
          )
        : null;
  },
  { deep: true }
);

/**
 * 地図・属性時間表示更新
 */
watch(
  () => mapTime.value,
  () => {
    emit("updateMapTime", mapTime.value);
  },
  { deep: true }
);

/**
 * 属性比較表示時間更新
 */
watch(
  () => attributeTime.value,
  () => {
    emit("updateAttributeTime", attributeTime.value);
  },
  { deep: true }
);

/**
 * 地図時間選択時イベント
 */
const selectMapDate = () => {
  mapTime.value.year = mapDate.value?.getFullYear().toString() ?? "";
  mapTime.value.month = mapDate.value
    ? (mapDate.value.getMonth() + 1)?.toString()
    : "";
  mapTime.value.day = mapDate.value?.getDate().toString() ?? "";
  emit("updateMapTime", mapTime.value);
};

/**
 * 属性時間選択時イベント
 */
const selectAttributeDate = () => {
  attributeTime.value.year =
    attributeDate.value?.getFullYear().toString() ?? "";
  attributeTime.value.month = attributeDate.value
    ? (attributeDate.value.getMonth() + 1).toString()
    : "";
  attributeTime.value.day = attributeDate.value?.getDate().toString() ?? "";
  emit("updateAttributeTime", attributeTime.value);
};

/**
 * 時間更新実行
 */
const updateMapTime = () => {
  emit("executeUpdateTime");
};

/**
 * 時間リセット
 */
const resetMapTime = () => {
  mapTime.value = {
    year: "",
    month: "",
    day: "",
    hour: 0,
    minute: 0,
  };
  mapDate.value = null;
  selectMapDate();
  attributeTime.value = {
    year: "",
    month: "",
    day: "",
    hour: 0,
    minute: 0,
  };
  attributeDate.value = null;
  selectAttributeDate();
  emit("resetMapTime");
};

return (_ctx: any,_cache: any) => {
  const _component_VueDatePicker = _resolveComponent("VueDatePicker")!

  return (_openBlock(), _createBlock(_unref(PopupWindow), {
    "data-html2canvas-ignore": "",
    windowId: "timeController",
    width: "510px",
    draggable: true,
    hideHeader: true,
    style: _normalizeStyle(dragStyle.value),
    isOpen: _ctx.isOpen
  }, {
    "main-content": _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(_unref(mapModifires)('time-controller', _ctx.modifires))
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_unref(FormUnit), {
            column: ['109px', '150px', '50px', '50px', 'auto'],
            "gap-column": "6px"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(FormUnitRow), { align: "right" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(FormUnitCell)),
                  _createVNode(_unref(FormUnitCell), null, {
                    default: _withCtx(() => [
                      _createTextVNode("年 月 日")
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(FormUnitCell), null, {
                    default: _withCtx(() => [
                      _createTextVNode("時")
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(FormUnitCell), null, {
                    default: _withCtx(() => [
                      _createTextVNode("分")
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(FormUnitCell))
                ]),
                _: 1
              }),
              _createVNode(_unref(FormUnitRow), null, {
                default: _withCtx(() => [
                  _createVNode(_unref(FormUnitCell), null, {
                    default: _withCtx(() => [
                      _createTextVNode("地図・属性表示対象")
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(FormUnitCell), null, {
                    default: _withCtx(() => [
                      _createVNode(_component_VueDatePicker, {
                        class: "date-picker",
                        locale: "jp",
                        "text-input": "",
                        "auto-apply": "",
                        "enable-time-picker": false,
                        format: "yyyy/MM/dd",
                        title: "月別での指定でも日までご指定ください",
                        modelValue: mapDate.value,
                        "onUpdate:modelValue": [
                          _cache[0] || (_cache[0] = ($event: any) => ((mapDate).value = $event)),
                          selectMapDate
                        ]
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(FormUnitCell), null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(SelectItem), {
                        value: mapTime.value.hour.toString(),
                        onUpdate: _cache[1] || (_cache[1] = 
                    (value) => {
                      mapTime.value.hour = Number(value);
                    }
                  )
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(24, (n) => {
                            return _createElementVNode("option", {
                              key: n - 1,
                              value: (n - 1).toString()
                            }, _toDisplayString(n - 1), 9, _hoisted_2)
                          }), 64))
                        ]),
                        _: 1
                      }, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(FormUnitCell), null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(SelectItem), {
                        value: mapTime.value.minute.toString(),
                        onUpdate: _cache[2] || (_cache[2] = 
                    (value) => {
                      mapTime.value.minute = Number(value);
                    }
                  )
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, (n) => {
                            return _createElementVNode("option", {
                              key: (n - 1) * 15,
                              value: ((n - 1) * 15).toString()
                            }, _toDisplayString((n - 1) * 15), 9, _hoisted_3)
                          }), 64))
                        ]),
                        _: 1
                      }, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(FormUnitCell), { align: "right" }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(ButtonItem), { onClick: updateMapTime }, {
                        default: _withCtx(() => [
                          _createTextVNode("実行")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_unref(FormUnitRow), null, {
                default: _withCtx(() => [
                  _createVNode(_unref(FormUnitCell), null, {
                    default: _withCtx(() => [
                      _createTextVNode("属性比較表示対象")
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(FormUnitCell), null, {
                    default: _withCtx(() => [
                      _createVNode(_component_VueDatePicker, {
                        class: "date-picker",
                        locale: "jp",
                        "text-input": "",
                        "auto-apply": "",
                        "enable-time-picker": false,
                        format: "yyyy/MM/dd",
                        title: "月別での指定でも日までご指定ください",
                        modelValue: attributeDate.value,
                        "onUpdate:modelValue": [
                          _cache[3] || (_cache[3] = ($event: any) => ((attributeDate).value = $event)),
                          selectAttributeDate
                        ]
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(FormUnitCell), null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(SelectItem), {
                        value: attributeTime.value.hour.toString(),
                        onUpdate: _cache[4] || (_cache[4] = 
                    (value) => {
                      attributeTime.value.hour = Number(value);
                    }
                  )
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(24, (n) => {
                            return _createElementVNode("option", {
                              key: n - 1,
                              value: (n - 1).toString()
                            }, _toDisplayString(n - 1), 9, _hoisted_4)
                          }), 64))
                        ]),
                        _: 1
                      }, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(FormUnitCell), null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(SelectItem), {
                        value: attributeTime.value.minute.toString(),
                        onUpdate: _cache[5] || (_cache[5] = 
                    (value) => {
                      attributeTime.value.minute = Number(value);
                    }
                  )
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, (n) => {
                            return _createElementVNode("option", {
                              key: (n - 1) * 15,
                              value: ((n - 1) * 15).toString()
                            }, _toDisplayString((n - 1) * 15), 9, _hoisted_5)
                          }), 64))
                        ]),
                        _: 1
                      }, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(FormUnitCell), { align: "right" }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(ButtonItem), {
                        onClick: resetMapTime,
                        negative: true
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("リセット")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ], 2)
    ]),
    _: 1
  }, 8, ["style", "isOpen"]))
}
}

})